import { Card, Checkbox, Space } from 'antd';
import { ProfileServiceRow } from '../../../profiles/sections/AgencyProfileServicesOffered';
import ImportTitle from './ImportTitle';
import React, {useState} from "react";

const ImportServiceOfferingsStep = ({ accountData, selectedFields, onFieldSelection, supplierOrg }) => {

    const [serviceOfferings, setServiceOfferings] = useState(TB.cloneDeep(accountData.service_offerings || []));

    return (
        <div className="py-6">
            <ImportTitle
                title="Service Offerings"
                description="Select the service offerings you'd like to import to your profile"
            />

            <Card title={
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <i className="fas fa-cogs" />
                        <span>Service Offerings ({serviceOfferings?.length || 0})</span>
                    </div>
                    <Space>
                        <Checkbox
                            checked={serviceOfferings?.every((_, idx) => selectedFields?.service_offerings?.[idx])}
                            onChange={(e) => {
                                const newValue = {};
                                serviceOfferings?.forEach((_, idx) => {
                                    newValue[idx] = e.target.checked;
                                });
                                onFieldSelection('service_offerings', newValue);
                            }}
                        >
                            <span className="text-xs text-gray-500">Select All</span>
                        </Checkbox>
                    </Space>
                </div>
            }>
                <Space direction="vertical" size={24} style={{ width: '100%' }}>
                    {serviceOfferings?.map((service, index) => (
                        <div key={`service-${TB.slugify(service.name || '')}-${index}`} className="flex items-start gap-4 flex-row" >
                            <Space>
                                <Checkbox
                                    checked={selectedFields?.service_offerings?.[index]}
                                    onChange={(e) => onFieldSelection('service_offerings', {
                                        ...(selectedFields?.service_offerings || {}),
                                        [index]: e.target.checked
                                    })}/>
                            </Space>
                            <div style={{ flex: 1 }}>
                                <div className="-mt-3">
                                    <ProfileServiceRow
                                        service={service}
                                        keyClients={supplierOrg?.key_clients}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </Space>
            </Card>
        </div>
    );
};

export default ImportServiceOfferingsStep;